export const SERVICE_RATING_REPORT_MODE = 'customer_display';

export function isServiceRatingReportEnabled(mode) {
  return typeof mode === 'string' && mode === SERVICE_RATING_REPORT_MODE;
}

export function selectedServiceRatingBranch(branches, selectedBranchId) {
  return (Array.isArray(branches) ? branches : []).find((branch) => branch && branch._id === selectedBranchId) || null;
}

// The staff rating report is open to everyone who can sign in (it used to be owner-only): the only condition is that the
// selected branch has Service Rating turned on. `isOwner` is accepted and ignored so older callers keep working.
export function canAccessServiceRatingReport({ branch }) {
  const setting = branch && branch.setting;
  return Boolean(setting) && isServiceRatingReportEnabled(setting.service_rating_mode);
}

export function shouldShowServiceRatingReport({ branches, selectedBranchId }) {
  return canAccessServiceRatingReport({
    branch: selectedServiceRatingBranch(branches, selectedBranchId)
  });
}

export function createEmptyServiceRatingSummary() {
  return {
    total_evaluation_opportunities: 0,
    completed_ratings: 0,
    timeout_count: 0,
    invalid_rating_count: 0,
    response_rate: 0,
    earned_score: 0,
    max_possible_score: 0,
    average_score: 0,
    rating_3_count: 0,
    rating_2_count: 0,
    rating_1_count: 0
  };
}

export function normalizeServiceRatingReport(result) {
  const source = result && typeof result === 'object' ? result : {};
  return {
    summary: Object.assign(createEmptyServiceRatingSummary(), source.summary || {}),
    employees: Array.isArray(source.employees) ? source.employees : []
  };
}
